import React from 'react';
import ExportButton from './ExportButton';
import styles from './tableHeader.module.css';

interface TableHeaderProps {
  title: string;
  onExport: () => void;
  /** Optional element rendered next to the title (e.g. a filter dropdown) */
  titleAddon?: React.ReactNode;
  /** Optional slot — use it to inject controls near the export button */
  children?: React.ReactNode;
}

const TableHeader: React.FC<TableHeaderProps> = ({ title, onExport, titleAddon, children }) => (
  <div className={styles.header}>
    <div className={styles.titleRow}>
      <span className={styles.title}>{title}</span>
      {titleAddon}
    </div>
    <div className={styles.controls}>
      {children}
      <ExportButton onClick={onExport} />
    </div>
  </div>
);

export default TableHeader;
